function trimSlash(url: string): string {
  return url.replace(/\/+$/, "");
}

const DEFAULT_APP_URL = "https://i151.djammadev.com";
const DEFAULT_CHALLENGE_URL = "https://i151.djamma.dev";

/** Origine du site vitrine / liens de partage (sans slash final). */
export const APP_URL = trimSlash(process.env.REACT_APP_APP_URL || DEFAULT_APP_URL);

/** Origine de la compétition IA (sans slash final). */
export const CHALLENGE_ORIGIN = trimSlash(
  process.env.REACT_APP_CHALLENGE_URL || DEFAULT_CHALLENGE_URL,
);

/** Page présentation du challenge. */
export const CHALLENGE_URL =
  process.env.REACT_APP_CHALLENGE_PAGE_URL || `${CHALLENGE_ORIGIN}/challenge`;
